import L_HTML5 from "../../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../../assets/img/skills/css3.svg";
import L_BOOTSTRAP from "../../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../../assets/img/skills/react.svg";
import L_REACT_BOOTSTRAP from "../../../assets/img/skills/react-bootstrap.svg";
import L_STYLED_COMPONENTS from "../../../assets/img/skills/styled-components.svg";
import L_NODE_JS from "../../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../../assets/img/skills/express.svg";
// import L_PYTHON from "../../../assets/img/skills/express.svg";
import L_MONGODB from "../../../assets/img/skills/mongodb.svg";
import L_POSTGRESQL from "../../../assets/img/skills/postgresql.svg";
import L_GIT from "../../../assets/img/skills/git-icon.svg";
import L_HEROKU from "../../../assets/img/skills/heroku.svg";
import L_DOCKER from "../../../assets/img/lfVWBmiW_400x400.png";
import L_DigitalOcean from "../../../assets/img/index.jpeg";
import L_JAVASCRIPT from "../../../assets/img/skills/javascript.svg";
import L_JQUERY from "../../../assets/img/skills/jqeury.png";
import L_MYSQL from "../../../assets/img/skills/mysql.png";
import CPP from "../../../assets/img/skills/cpp.jpg";
import reactRedux from "../../../assets/img/skills/react-redux.png";
import typescript from "../../../assets/img/skills/typescript.png";

export const tech = {
	frontend: [
		{
			link: "https://en.wikipedia.org/wiki/HTML5",
			alt: "HTML 5",
			imgSrc: L_HTML5,
			name: "HTML5",
		},

		{
			link: "https://en.wikipedia.org/wiki/CSS",
			alt: "CSS 3",
			imgSrc: L_CSS3,
			name: "CSS3",
		},

		{
			link: "https://jQuery.com",
			alt: "jQuery",
			imgSrc: L_JQUERY,
			name: "jQuery",
		},

		{
			link: "https://getbootstrap.com/",
			alt: "Bootstrap",
			imgSrc: L_BOOTSTRAP,
			name: "Bootstrap",
		},

		{
			link: "https://reactjs.org/",
			alt: "React JS",
			imgSrc: L_REACT,
			name: "React JS",
		},

		{
			link: "https://react-bootstrap.github.io/",
			alt: "React Bootstrap",
			imgSrc: L_REACT_BOOTSTRAP,
			name: "React Bootstrap",
		},

		{
			link: "https://styled-components.com/",
			alt: "styled-components",
			imgSrc: L_STYLED_COMPONENTS,
			name: "styled-components",
		},

		{
			link: "https://redux.js.org/",
			alt: "React-Redux",
			imgSrc: reactRedux,
			name: "React-Redux",
		},
	],

	backend: [
		{
			link: "https://nodejs.org/en/",
			alt: "Node.js",
			imgSrc: L_NODE_JS,
			name: "Node.js",
		},
		{
			link: "https://expressjs.com/",
			alt: "Express",
			imgSrc: L_EXPRESS,
			name: "Express",
		},

		{
			link: "https://www.postgresql.org/",
			alt: "PostgreSQL",
			imgSrc: L_POSTGRESQL,
			name: "PostgreSQL",
		},

		{
			link: "https://www.mysql.com/",
			alt: "MS-SQL",
			imgSrc: L_MYSQL,
			name: "MY-SQL",
		},
		{
			link: "https://www.mongodb.com/",
			alt: "MongoDB",
			imgSrc: L_MONGODB,
			name: "MongoDB",
		},
	],

	programmingLanguages: [
		{
			link: "https://www.javascript.com/",
			alt: "JavaScript",
			imgSrc: L_JAVASCRIPT,
			name: "JavaScript",
		},

		{
			link: "https://www.typescriptlang.org/",
			alt: "TypeScript",
			imgSrc: typescript,
			name: "TypeScript",
		},

		{
			link: "https://www.cplusplus.com/reference/",
			alt: "C++",
			imgSrc: CPP,
			name: "C++",
		},
	],

	other: [
		{
			link: "https://git-scm.com/",
			alt: "GIT",
			imgSrc: L_GIT,
			name: "GIT",
		},

		{
			link: "https://www.heroku.com/",
			alt: "Heroku",
			imgSrc: L_HEROKU,
			name: "Heroku",
		},

		{
			link: "https://docs.docker.com/",
			alt: "Docker",
			imgSrc: L_DOCKER,
			name: "Docker",
		},

		{
			link: "https://www.digitalocean.com/",
			alt: "DigitalOcean",
			imgSrc: L_DigitalOcean,
			name: "DigitalOcean",
		},
	],
};
